import React from "react";
import AnimatedCard from "../AnimatedCard/AnimatedCard";
import Odometer from "../Odometer/Odometer";
import classes from "./Figure.module.css";


//This Component renders 2 divs with Odometers inside to show some numbers with an icon in between
//and a title beneath
// prop = { leftNumber, rightNumber, icon, title} 
const Figure = (props) => {
  return (
    <AnimatedCard className={classes.container}>
      <div className={classes.row}>
        <div className={classes.leftCard}>
          <div className={classes.numberContainer}>
            <Odometer
              value={props.leftNumber}
              height={40}
              className={classes.yellow + " " + classes.number}
              commaClassName={classes.blue}
              duration={1}
            />
          </div>
          <div className={classes.label + " " + classes.yellow}>Disabled</div>
        </div>
        <img src={props.icon} alt="icon" className={classes.icon} />
        <div className={classes.rightCard}>
          <div className={classes.numberContainer}>
            <Odometer
              value={props.rightNumber}
              height={40}
              className={classes.blue + " " + classes.number}
              commaClassName={classes.yellow}
              duration={1}
            />
          </div>
          <div className={classes.label + " " + classes.blue}>Non-Disabled</div>
        </div>
      </div>
      <div className={classes.row}><h4>{props.title}</h4></div>
    </AnimatedCard>
  );
};
export default Figure;
